import React, { useEffect, useState } from 'react'
import './styles.scss'
interface Props {
  id: string
  url: string
}
const isLocalHost = location.href.includes('localhost')
const allowedDomains = [
  'https://interaktiv.tagesanzeiger.ch',
  'https://interaktiv.bernerzeitung.ch',
  'https://interaktiv.tdg.ch',
  'https://interaktiv.derbund.ch',
  'https://interaktiv.24heures.ch',
  'https://interaktiv.bazonline.ch'
]
export const StandaloneIFrame = ({ id, url }: Props) => {
  const [height, setHeight] = useState<number>(60)
  const iframeRef = React.createRef()
  // const iframeRef = useState<HTMLIFrameElement | null>(null)
  const handleMessage = m => {
    if (
      m.data.type === 'size-change' &&
      allowedDomains.indexOf(m.origin) !== -1
    ) {
      if (m.data.data.id === id) {
        setHeight(m.data.data.height)
      }
    }
  }

  useEffect(() => {
    if (!isLocalHost) {
      window.addEventListener('message', handleMessage)
      return () => {
        // unsubscribe event
        window.removeEventListener('message', handleMessage)
      }
    }
  }, [])

  useEffect(() => {
    if (iframeRef !== null && !iframeRef.current) return
    let cont = iframeRef.current.contentWindow

    if (!isLocalHost) {
      const interval = setInterval(() => {
        let message = {
          type: 'size-change',
          data: { id: id, height: cont.document.body.offsetHeight }
        }
        cont.parent.postMessage(message, isLocalHost ? location.origin : '*')
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [iframeRef.current])

  return (
    <iframe
      className='standaloneiframe'
      src={url}
      id={id}
      ref={iframeRef}
      style={{ height: height + 'px' }}
    />
  )
}
